module.exports = __webpack_public_path__ + "img/zont2.12c9de8b.png";